import { Injectable } from "@angular/core";
import { IDmsMeta } from "@calaosoft/osapp-common/dms/models/idms-meta";
import { IEntity } from "@calaosoft/osapp-common/entities/models/ientity";
import { MetaEntityBuilderBase } from "@calaosoft/osapp-mobile/modules/dms/model/MetaEntityBuilderBase";

@Injectable()
export class MetaMerchBuilderBase extends MetaEntityBuilderBase {
	//#region METHODS

	public override prepareMeta(poEntity: IEntity, poMeta: IDmsMeta): Promise<IDmsMeta> {
		poMeta.documentType = this.getEntityDocumentType(poEntity);

		return Promise.resolve(poMeta);
	}

	public override getEntityDocumentType(poEntity: IEntity): string {
		return "RPTDOC";
	}

	//#endregion
}
